import React from "react";
import PropTypes from "prop-types";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Card, CardImg, CardBody, Badge, CardTitle } from "reactstrap";
import "../assets/styles/ClassroomCard.scss";
// import { ZoomMtg } from "@zoomus/websdk";
import { useEffect } from "react";

const ClassroomCard = ({ title, description, buttonText, img, href_link }) => {
  // const crypto = require("crypto"); // crypto comes with Node.js

  // function generateSignature(apiKey, apiSecret, meetingNumber, role) {
  //   return new Promise((res, rej) => {
  //     // Prevent time sync issue between client signature generation and Zoom

  //     const timestamp = new Date().getTime() - 30000;
  //     const msg = Buffer.from(
  //       apiKey + meetingNumber + timestamp + role
  //     ).toString("base64");
  //     const hash = crypto
  //       .createHmac("sha256", apiSecret)
  //       .update(msg)
  //       .digest("base64");
  //     const signature = Buffer.from(
  //       apiKey,
  //       meetingNumber,
  //       timestamp,
  //       role,
  //       hash
  //     ).toString("base64");
  //     res(signature);
  //   });
  // }

  // useEffect(() => {
  //   ZoomMtg.preLoadWasm();
  //   ZoomMtg.prepareJssdk();
  //   ZoomMtg.setZoomJSLib("https://source.zoom.us/2.4.5/lib", "/av");
  // });

  // const apiKey = "YA6G2w9qTQu9KIvDY2yMw";
  // const apiSecret = "7VS9JBIhB7K1bGFLpGvizEBTgLJLv864";
  // const meetingNumber = "123456789";
  // const role = 0;
  // const leaveUrl = "http://localhost:3000";
  // const userName = "React";
  // const userEmail = "";
  // const passWord = "";
  // const registrantToken = "";
  // const signature = "";
  // generateSignature(apiKey, apiSecret, meetingNumber, role).then((res) => {
  //   signature = res;
  // });

  // const showZoomDiv = () => {
  //   document.getElementById("zmmtg-root").style.display = "block";
  // };

  // const initiateMeeting = () => {
  //   ZoomMtg.init({
  //     leaveUrl: leaveUrl,
  //     success: (success) => {
  //       console.log(success);

  //       ZoomMtg.join({
  //         signature: signature,
  //         meetingNumber: meetingNumber,
  //         userName: userName,
  //         // sdkKey: sdkKey,
  //         userEmail: userEmail,
  //         passWord: passWord,
  //         success: (success) => {
  //           console.log(success);
  //         },
  //         error: (error) => {
  //           console.log(error);
  //         },
  //       });
  //     },
  //     error: (error) => {
  //       console.log(error);
  //     },
  //   });
  // };
  return (
    <Card className="classroom-card rounded">
      {/* <CardImg
        top
        className="rounded-top"
        width="100%"
        src={require("../assets/img/" + img)}
        alt=" "
      /> */}
      {/* <CardBody className="rounded-bottom">
        <CardTitle>{title}</CardTitle>
      </CardBody> */}
      <CardBody className="rounded">
        <CardTitle>1대1 {title}</CardTitle>
      </CardBody>

      <div className="reveal rounded">
        <CardTitle>1대1 {title}</CardTitle>
        <div className="reveal-body">{description}</div>
        <a href={href_link} target="_blank">
          {/* <button className="btn reveal-button" onClick={initiateMeeting}> */}
          <button className="btn reveal-button">{buttonText}</button>
        </a>
      </div>
    </Card>
  );
};

ClassroomCard.propTypes = {
  title: PropTypes.string.isRequired,
  category: PropTypes.string,
  description: PropTypes.string.isRequired,
  labels: PropTypes.arrayOf(PropTypes.string),
  tags: PropTypes.arrayOf(PropTypes.string),
  buttonText: PropTypes.string,
  img: PropTypes.string.isRequired,
};

ClassroomCard.defaultProps = {
  category: "",
  labels: [],
  tags: [],
  buttonText: "자세히",
};

export default ClassroomCard;
